var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandExchangesIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 0v6h2.5v8.5H10V16h4v-4h-4v1.5H5.5v-4H10V11h4V7h-4v1.5H5.5V6H8V0zm5 1H3v4h4zm6 14h-2v-2h2zm-2-5h2V8h-2z",
  clipRule: "evenodd"
})));
export default SvgExpandExchangesIcon;